import Button from '@/src/common/components/marketing/buttons/Button'
import { NextRouter } from 'next/router'

type TMaxKYCButtonProps = {
    isLoading: boolean
    setIsLoading: Function
    cartTotalCards: number
    setCartFlyoutOpen: Function
    router: NextRouter
}

const KYCMaxPurchaseButtons = ({
    isLoading,
    setIsLoading,
    cartTotalCards,
    setCartFlyoutOpen,
    router,
}: TMaxKYCButtonProps) => {
    return (
        <>
            <Button
                id={'submit-button'}
                label={'Continue to corporate'}
                showArrow={true}
                onClick={() => {
                    setIsLoading(true)
                    router
                        .push(`/corporate/get-started?variant=default`)
                        .then(() => {})
                }}
                textTransform={'uppercase'}
                isLoading={isLoading}
                disabled={isLoading}
                style={{ marginBottom: 10 }}
                width={'wide'}
            />
            {cartTotalCards > 0 && (
                <Button
                    id={'edit-cart-button'}
                    variant={'primaryOutline'}
                    label={'Edit cart'}
                    showArrow={true}
                    onClick={() => setCartFlyoutOpen(true)}
                    textTransform={'uppercase'}
                    isLoading={isLoading}
                    disabled={isLoading}
                    width={'wide'}
                />
            )}
        </>
    )
}

export default KYCMaxPurchaseButtons
